import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import Form from "../../../common/form";
import { listRequest } from "../../../../store/slices/rolesSlice";
import { bulkCreateRequest } from "../../../../store/slices/usersSlice";
import AddUserForm from "./AddUserForm";

const AddUser = ({
  action,
  bulkCreateRequest,
  error,
  labels,
  listRequest,
  parent,
  requesting,
  roles,
}) => {
  useEffect(() => {
    listRequest();
  }, [listRequest]);

  const defaultRole = roles.find((role) => role.name === "Learner");

  const navigate = useNavigate();
  const intl = useIntl();

  const bulkCreateUsers = (data) => {
    const payload = data.users.map((user) => ({
      ...user,
      roleId: user.roleId.id || defaultRole.id,
    }));
    bulkCreateRequest({
      learners: payload,
    });
  };

  useEffect(() => {
    if (
      !requesting &&
      !error &&
      (action === "bulk-create" || action === "update" || action === "delete")
    ) {
      navigate(parent.to);
    }
  }, [requesting, error, action, navigate, parent.to]);

  return (
    <div>
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "add_user" })}
          </div>
        </div>
        <div className="edexlms-page-body">
          <Form
            submitBtn={{
              label: intl.formatMessage({ id: "add_users" }),
              onClick: bulkCreateUsers,
            }}
            cancelBtn={{
              label: intl.formatMessage({ id: "cancel" }),
              onClick: () => navigate(parent.to),
            }}
            initialValues={{
              users: [
                { firstName: "", lastName: "", roleId: defaultRole, email: "" },
              ],
            }}
            requesting={requesting}
          >
            <AddUserForm defaultRole={defaultRole} />
          </Form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  roles: state.roles?.data?.list || [],
  action: state?.users?.action,
  error: state?.users?.error,
  requesting: state?.users?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  listRequest: () => dispatch(listRequest()),
  bulkCreateRequest: (data) => dispatch(bulkCreateRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
